<template lang="pug">
  ul.ods-actions-menu__ul.ods-actions-menu--user__ul
    li.user-ul__user-name
      | {{userName}}
      | {{userMail}}
    li.ods-actions-menu__separator
    li
      lang-selector(
        cssClass="user-ul__languages"
        :mobile="isMobile")
    li.ods-actions-menu__separator
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="user")
          | Profile
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="setting")
          | Subsection
    router-link(
      to="/User"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="user-role")
          | {{$t('header.user.account')}}
    li.ods-actions-menu__separator
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="book")
          | Help
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="list")
          | Suggest a feature
    //- li.ods-actions-menu__separator
    ods-select(
      v-model="themeSelector"
      @change="handleTheme"
      :selectLabel="$t('header.user.theme')"
      class="user-ul__languages")
      ods-option(key="1" value="light")
      ods-option(key="2" value="dark")
    li.ods-actions-menu__separator
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="info")
          | Privacy & cookies
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="info")
          | Software licenses
    //- router-link(
      to="/Home"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="info")
          | Terms & conditions
    //- li.ods-actions-menu__separator
    router-link(
      to="/login"
      custom
      v-slot="{ href, navigate }")
      li(
        @click="navigate"
        @keypress.enter="navigate"
        role="link"
      )
        a(:href="href")
          ods-icon(name="logout")
          | {{$t('header.user.logout')}}
</template>

<script>
import LangSelector from '@/components/shared/LangSelector'
import { mapGetters } from 'vuex'

export default {
  name: 'UserMenu',

  components: {
    LangSelector
  },

  data () {
    return {
      langSelector: '',
      themeSelector: 'light',
      userName: sessionStorage.username,
      userMail: sessionStorage.usermail
    }
  },

  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },

  methods: {
    handleTheme (val) {
      document.querySelector('html').dataset.theme = val
      window.localStorage.setItem('theme', val)
    }
  }
}
</script>
